import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

export const PageHero = ({ eyebrow, title, subtitle, current }) => {
  return (
    <section className="relative bg-charcoal text-canvas overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-charcoal via-charcoal to-forest/40 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 pt-32 pb-14 md:pt-40 md:pb-20">
        {/* Breadcrumb */}
        <nav
          data-testid="page-breadcrumb"
          aria-label="Breadcrumb"
          className="flex items-center gap-2.5 font-sans text-[11px] tracking-[0.14em] uppercase"
        >
          <Link to="/" className="text-canvas/50 hover:text-gold transition-colors duration-300">
            Home
          </Link>
          <ChevronRight className="w-3 h-3 text-canvas/30" strokeWidth={1.5} />
          <span className="text-canvas">{current}</span>
        </nav>

        <div className="mt-8">
          {eyebrow && (
            <span className="font-sans text-[11px] tracking-[0.28em] uppercase text-gold">
              {eyebrow}
            </span>
          )}
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
            className="mt-4 font-serif text-[26px] sm:text-[34px] lg:text-[42px] leading-[1.03] max-w-4xl"
          >
            {title}
          </motion.h1>
          {subtitle && (
            <p className="mt-5 font-serif text-base md:text-lg text-canvas/70 max-w-2xl leading-snug">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};
